import * as React from 'react';
import { Popover } from '@blueprintjs/core';
import { find } from 'lodash';
import Icon from '../../../../Components/Icon';
import Menu from '../../../../Components/Menu';
import CheckboxWithLabel, { ICheckboxWithLabelProps } from '../../../../Components/CheckboxWithLabel';

import './styles.scss';
import classNames from 'classnames';

export interface IFilterDropProps {
    /** Label to render */
    label: React.ReactNode;
    /** Options to choose from */
    options: {
        id: string;
        label: React.ReactNode;
        value?: string;
    }[];
    /** Selected options */
    selectedOptions: IFilterDropProps['options'];
    /** Change event from option */
    onChange: ICheckboxWithLabelProps['onChange'];
}

/**
 * Renders DOM string to clickable link.
 */
const FilterDrop: React.FunctionComponent<IFilterDropProps> = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClosePopover = () => {
        setOpen(false);
    };

    // Main output

    return (
        <Popover
            enforceFocus={true}
            position="bottom-left"
            usePortal={true}
            minimal={true}
            autoFocus={true}
            isOpen={open}
            boundary="scrollParent"
            onClose={handleClosePopover}
            className={classNames('filter-drop', { active: !!props.selectedOptions.length, })}
            popoverClassName="filter-drop__popover"
            portalClassName="filter-drop__portal"
            modifiers={{
                offset: {
                    offset: '0, 0',
                },
                flip: {
                    enabled: false,
                },
            }}
            content={(
                <Menu>
                    {props.options.map((option, optionIndex) => {
                        const isChecked = !!find(props.selectedOptions, { id: option.id });
                        return (
                            <CheckboxWithLabel
                                key={option.id}
                                label={option.label}
                                value={option.value}
                                checked={isChecked}
                                onChange={props.onChange}
                            />
                        );
                    })}
                </Menu>
            )}
            target={(
                <div
                    className="filter-drop__target"
                    role="button"
                    aria-controls="t1"
                    onClick={(e) => {
                        e.preventDefault();
                        setOpen(true);
                    }}
                >
                    <div className="filter-drop__target__label">{props.label}</div>
                    {!!props.selectedOptions.length && (
                        <div className="filter-drop__target__count">{props.selectedOptions.length}</div>
                    )}
                    <Icon kind="arrow1-down" width={12} height={12}/>
                </div>
            )}
            transitionDuration={0}
            hoverOpenDelay={0}
            hoverCloseDelay={100}
        />
    );
};

FilterDrop.displayName = 'FilterDrop';

export default FilterDrop;
